module.exports = __webpack_public_path__ + "static/ks-collect/img/order-fans.c9db1b8c.png";